<template>
  <main class="mt-5">
    <transition>
      <div v-if="loading" class="d-flex justify-content-center w-100 mt-3">
        <Loading />
      </div>
      <div v-else>
        <div class="card mt-3">
          <div class="card-header border-0 d-flex justify-content-between">
            <h5 class="card-title">وزن محصول</h5>
            <b-button
              v-if="items.length == 0"
              @click="addRow()"
              variant="primary"
              >افزودن سطر</b-button
            >
          </div>
          <div class="card-body">
            <table class="table">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>از وزن</th>
                  <th>تا وزن</th>
                  <th>قیمت</th>
                  <th>تغییرات</th>
                </tr>
                <tr v-for="(item, index) in items" :key="index">
                  <th>
                    {{ index + 1 }}
                  </th>
                  <td>
                    <div class="selectWeight">
                      <treeselect
                        :flat="true"
                        :searchable="true"
                        :multiple="false"
                        :options="weights"
                        noChildrenText="فرزندی وجود ندارد"
                        noOptionsText="موردی وجود ندارد"
                        noResultsText="موردی یافت نشد"
                        placeholder="انتخاب وزن"
                        v-model="item.weight_from"
                      />
                    </div>
                  </td>
                  <td>
                    <div class="selectWeight">
                      <treeselect
                        :flat="true"
                        :searchable="true"
                        :multiple="false"
                        :options="weights"
                        noChildrenText="فرزندی وجود ندارد"
                        noOptionsText="موردی وجود ندارد"
                        noResultsText="موردی یافت نشد"
                        placeholder="انتخاب وزن"
                        v-model="item.weight_to"
                      />
                    </div>
                  </td>
                  <td>
                    <b-form-input v-model="item.price"> </b-form-input>
                  </td>
                  <td>
                    <div class="d-flex" style="gap: 8px">
                      <b-button variant="danger" @click="deleteRow(index)">
                        <i class="fa fa-trash"></i>
                      </b-button>
                      <b-button
                        v-if="index == items.length - 1"
                        @click="addRow()"
                        variant="primary"
                        >افزودن سطر</b-button
                      >
                    </div>
                  </td>
                </tr>
              </thead>
            </table>
            <b-button :disabled="disable" @click="submit()" variant="primary">
              ثبت تغییرات
            </b-button>
          </div>
        </div>
      </div>
    </transition>
  </main>
</template>

<script>
import productsWeightsImpl from "@@/core/pages/product/productsWeights/productsWeightsImpl";
export default {
  extends: productsWeightsImpl,
};
</script>
<style scoped>
.selectWeight {
  max-width: 320px;
}
</style>
